import { Inject, Injectable, InjectionToken } from '@angular/core';
import { PaginatedState, PaginatedStateLoadingMode, PaginatedStateModel } from '@shared/ui';

export interface DeviceTypeData {
  id: string;
  name: string;
  version: string;
  numDevices?: number; // undefined = not loaded yet (deferred loading)
}

export type DeviceTypeStateModel = PaginatedStateModel<DeviceTypeData>;

export const DEVICE_TYPE_PAGINATION = new InjectionToken<PaginatedStateLoadingMode>('DEVICE_TYPE_PAGINATION');

@Injectable()
export class DeviceTypeState extends PaginatedState<DeviceTypeData, DeviceTypeStateModel> {
  constructor(@Inject(DEVICE_TYPE_PAGINATION) pagination: PaginatedStateLoadingMode) {
    super({ maxConcurrentCountQueries: 2, loadingMode: pagination });
  }

  // Expose selectors with original names for backwards compatibility
  public readonly deviceTypes$ = this.items$;
  public readonly nextDeviceTypeToken$ = this.nextToken$;
  public readonly previousDeviceTypeTokens$ = this.previousTokens$;
  public readonly deviceTypesLoaded$ = this.itemsLoaded$;
  public readonly noDeviceTypes$ = this.noItems$;
}
